if (!customElements.get('feature-cards')) {
  customElements.define(
    'feature-cards',
    class FeatureCards extends HTMLElement {
      connectedCallback() {
        if (this.dataset.slider !== 'true') return;

        this.sliderElement = this.querySelector('.splide');
        if (!this.sliderElement) return;

        if (window.Splide) {
          this.mountSplide();
        } else {
          // Splide loads with `defer` from a CDN; if this runs first, wait for it.
          window.addEventListener('load', () => this.mountSplide(), { once: true });
        }

        // In the theme editor, jump to a card when it is selected.
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('.fcs__slide');
          const slides = Array.from(this.querySelectorAll('.fcs__slide:not(.splide__slide--clone)'));
          const index = slides.indexOf(slide);
          if (this.splide && index > -1) this.splide.go(index);
        });
      }

      disconnectedCallback() {
        if (this.splide) this.splide.destroy();
      }

      mountSplide() {
        if (!window.Splide || this.splide || !this.sliderElement) return;

        const data = this.dataset;
        const number = (value, fallback) => parseInt(value, 10) || fallback;
        const fixed = data.sizing === 'fixed';
        const gapDesktop = `${number(data.gapD, 0)}px`;
        const gapMobile = `${number(data.gapM, 0)}px`;

        const options = {
          type: data.sliderType || 'slide',
          rewind: data.sliderType !== 'loop',
          focus: data.align === 'center' ? 'center' : 0,
          trimSpace: data.align !== 'center',
          gap: gapDesktop,
          speed: number(data.speed, 600),
          drag: data.drag === 'true',
          arrows: data.arrows === 'true',
          pagination: data.pagination === 'true',
          autoplay: data.autoplay === 'true',
          interval: number(data.interval, 5000),
          pauseOnHover: data.pauseOnHover === 'true',
        };

        if (fixed) {
          options.fixedWidth = `${number(data.cardWD, 280)}px`;
          options.breakpoints = {
            749: { fixedWidth: `${number(data.cardWM, 280)}px`, gap: gapMobile },
          };
        } else {
          options.perPage = number(data.colsD, 3);
          options.breakpoints = {
            989: { perPage: number(data.colsT, 2) },
            749: { perPage: number(data.colsM, 1), gap: gapMobile },
          };
        }

        this.splide = new window.Splide(this.sliderElement, options);
        this.splide.mount();
      }
    }
  );
}
